export default __webpack_public_path__ + "static/media/donlon.32132788.svg";